<template>
  <div>
    <p class="mb-3" v-html="$sanitize(payload.content)"></p>
    <LinkEntity :payload="payload.resources.position" :additional_data="{ center: true, resource_type: 'Position' }" />
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'

export default {
  name: 'FeedContentFollowUpPosition',
  components: {
    LinkEntity
  },
  props: {
    payload: {
      type: Object
    }
  },
  created () {
    console.log(this.payload)
  }
}
</script>
